/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { css } from "@emotion/react";

import { useStaticQuery, graphql } from "gatsby";
import Header from "./Header";
import "../styles/global.css";
import icon from "../../static/images/venn-icon.png";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <Helmet>
        <link rel="icon" type="image/png" href={icon} />
      </Helmet>
      <div>
        <main>{children}</main>
        <footer>
          <p>© Jack Lo Russo, {new Date().getFullYear()}</p>
          <br></br>
          <p
            css={css`
              font-size: var(--scale-m1);
              width: 75%;
            `}
          >
            This&nbsp;site respects your system preference for dark/light mode ♡
          </p>
        </footer>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
